import { render, staticRenderFns } from "./EmailConfigView.vue?vue&type=template&id=0f909de6&scoped=true"
import script from "./EmailConfigView.vue?vue&type=script&lang=js"
export * from "./EmailConfigView.vue?vue&type=script&lang=js"
import style0 from "./EmailConfigView.vue?vue&type=style&index=0&id=0f909de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f909de6",
  null
  
)

export default component.exports